import React from 'react'
import ReactDOM from 'react-dom'
import MultishareContainer from './multishareContainer.js'
import {Provider} from 'react-redux'
import {createStore, applyMiddleware} from 'redux'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import multishareReducers from '../../reducers/index.js'

$(document).ready(() => {
  var content = document.getElementById('multishare-content');


  let loggerMiddleware = createLogger();

  var store = createStore(multishareReducers,
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware
    )
  );

  if (content) {
    var elem = (
      <Provider store={store}>
        <MultishareContainer
          isNewEditor="true"
        />
      </Provider>
    );
    ReactDOM.render(elem, content);
  } else {
    //in karma, this file is loaded but there is no document
    //console.error('Missing content element for react');
  }
});




// WEBPACK FOOTER //
// ./components/multishare/main.js